import { useEffect } from 'react';

const Title = ({ title }: { title?: string }) => {
  useEffect(() => {
    const newTitle = title ? 'Hubert | ' + title : 'Hubert';
    document.title = newTitle;

    return () => {
      document.title = 'Hubert';
    };
  }, [title]);

  return null;
};

export default Title;
